import { render, staticRenderFns } from "./EditStoreCouponComponent.vue?vue&type=template&id=1f3a25c2&scoped=true"
import script from "./EditStoreCouponComponent.vue?vue&type=script&lang=js"
export * from "./EditStoreCouponComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3a25c2",
  null
  
)

export default component.exports